import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Maps every ReturnRequest status to a colored Chip with bilingual label.
// Statuses are aligned with the backend's ReturnRequest::STATUSES enum.
export const RETURN_STATUS_META = {
    pending:           { color: 'warning', labelEn: 'Pending',           labelAr: 'قيد المراجعة' },
    approved:          { color: 'info',    labelEn: 'Approved',          labelAr: 'موافق عليه' },
    rejected:          { color: 'error',   labelEn: 'Rejected',          labelAr: 'مرفوض' },
    awaiting_shipment: { color: 'info',    labelEn: 'Awaiting Shipment', labelAr: 'بانتظار الشحن' },
    in_transit:        { color: 'primary', labelEn: 'In Transit',        labelAr: 'قيد النقل' },
    received:          { color: 'primary', labelEn: 'Received',          labelAr: 'تم الاستلام' },
    completed:         { color: 'success', labelEn: 'Completed',         labelAr: 'مكتمل' },
    refunded:          { color: 'success', labelEn: 'Refunded',          labelAr: 'تم رد المبلغ' },
    cancelled:         { color: 'default', labelEn: 'Cancelled',         labelAr: 'ملغي' },
};

const ReturnStatusBadge = ({ status, sx }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const meta = RETURN_STATUS_META[status] || {
        color: 'default',
        labelEn: status || '-',
        labelAr: status || '-',
    };

    return (
        <Chip
            label={isArabic ? meta.labelAr : meta.labelEn}
            size="small"
            color={meta.color}
            variant="tonal"
            sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: '90px', ...sx }}
        />
    );
};

export default ReturnStatusBadge;
